import { instance } from '.';
import * as storage from '../storage';

export const login = async (credentials: any) => {
    const response = await instance.post(`auth/login`, { ...credentials });

    storage.set('access_token', response.data.access_token);

    return response.data;
}